"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var get_url_to_widget_1 = (0, tslib_1.__importDefault)(require("./get-url-to-widget"));
exports.default = (function (_a) {
    var siteUrl = _a.siteUrl, compId = _a.compId;
    return (0, get_url_to_widget_1.default)(siteUrl, compId);
});
//# sourceMappingURL=get-url-to-channel.js.map